import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_WORKPACKS,
  LINK_WORKPACK_JOBS,
  UPDATE_WORKPACK,
} from '../../../graph-queries/tar/workpack';
import { TWorkpack } from '../../../lib/types';
import AspectsTable from '../../organisms/AspectsTable/AspectsTable';
import WorkpackForm from '../WorkpackForm/WorkpackForm';
import { columns } from '../../pages/Workpacks/Workpacks';
import classes from './JobAspects.module.scss';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobWorkpacks: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data } = useQuery(GET_JOB_WORKPACKS, {
    variables: { jobId },
  });
  const [updateWorkpack] = useMutation(UPDATE_WORKPACK, {
    refetchQueries: [GET_JOB_WORKPACKS],
  });
  const [linkWorkpackJobs] = useMutation(LINK_WORKPACK_JOBS, {
    refetchQueries: [GET_JOB_WORKPACKS],
  });

  const onEditSubmit = (workpack: TWorkpack) => {
    return updateWorkpack({ variables: workpack });
  };

  const onLinkSubmit = (selection: TWorkpack[], jobIds: number[]) => {
    return Promise.all(
      selection.map((workpack) =>
        linkWorkpackJobs({
          variables: {
            workpackId: workpack.workpackId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TWorkpack>
      aspectName="workpack"
      data={(data?.workpacksByJobId as unknown as TWorkpack[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <WorkpackForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Workpacks</div>}
    />
  );
};

export default JobWorkpacks;
